var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "CSChatThai", staticStyle: { background: "#2562af" } },
    [
      _c(
        "div",
        { staticStyle: { background: "#2562af !important", padding: "10px" } },
        [
          _c(
            "v-btn",
            {
              staticStyle: { margin: "0 !important" },
              attrs: { icon: "" },
              on: {
                click: function($event) {
                  return _vm.goback()
                }
              }
            },
            [
              _c(
                "v-icon",
                {
                  staticClass: "white--text",
                  staticStyle: { "font-size": "24px" }
                },
                [_vm._v("chevron_left")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                color: "white",
                "font-weight": "800",
                "margin-left": "25vw"
              }
            },
            [_vm._v("สถานะ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            padding: "10px",
            "border-top-left-radius": "20px",
            "border-top-right-radius": "20px",
            background: "#fafafa"
          }
        },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", xl12: "", lg12: "", md12: "", sm12: "" } },
                [
                  _c("p", { staticClass: "HeadersDetail" }, [_vm._v("สถานะ")]),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: {
                      solo: "",
                      placeholder: "สถานะ",
                      height: "35",
                      counter: "75"
                    },
                    model: {
                      value: _vm.status,
                      callback: function($$v) {
                        _vm.status = $$v
                      },
                      expression: "status"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btnSave",
                      attrs: {
                        disabled: _vm.status.length > 75 ? true : false,
                        small: ""
                      },
                      on: {
                        click: function($event) {
                          return _vm.Save_status()
                        }
                      }
                    },
                    [_vm._v("บันทึก")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c197fda", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c197fda","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mail/Edit/edit_status.vue
// module id = null
// module chunks = 